import Bowser from 'bowser';
import { getRecaptcha } from './form';

$('.ocr-file').on('change', async function () {
    $('input[name="uuid"]').remove();
    $('.file-error').remove();

    const file = this.files[0]
    if (!file) {
        return;
    }
    let formData = new FormData()
    formData.set('file', file)
    formData.set('g-recaptcha-response', await getRecaptcha())
    formData.set('_token', $(this).data('token'))
    formData.set('wsUuid', await getWebsocketUuid());
    openWebSocket(formData.get('wsUuid'));

    try {
        var data = await $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            data: formData,
            processData: false,
            contentType: false,
        });
    } catch (xhr) {
        let message = Object.values(xhr.responseJSON?.errors ?? []).flat().join('<br>') || 'Wystąpił nieznany błąd, proszę spróbować jeszcze raz.';
        $(this).closest('.form-group').append(`<div class="invalid-feedback d-block file-error">${message}</div>`)
        return;
    }
    $('#file-name').val(file.name)
    $('form.application-form').find('[name=receiptUuid]').remove();
    $('form.application-form').append(`<input type="hidden" name="receiptUuid" value="${data.receiptUuid}">`);
    for (let name in data.billData) {
        $(`input[name="personal_data[${name}]"]`).val(data.billData[name]).trigger('input');
    }
});

function getWebsocketUuid() {
    return fetch(WEBSOCKET_UUID_URL)
        .then(response => response.json())
        .then(data => data.uuid);
}

function openWebSocket(uuid) {
    var ws = new WebSocket(OCR_URL.replace(/^https?:\/\//, 'wss://') + 'ws');
    ws.onmessage = data => { 
        $('#ocrAwaitingDataView').html($('#ocrAwaitingDataView').html() + data.data.replace('\n', '<br />'));
        $('#ocrAwaitingDataView').scrollTop($('#ocrAwaitingDataView')[0].scrollHeight);
    };
    ws.onopen = () => ws.send(JSON.stringify({ uuid: uuid }));
}

$('.ocr-file').on('click', function (e) {
    if (['mobile', 'tablet'].includes(Bowser.parse(navigator.userAgent).platform.type)) {
        e.preventDefault();

        $('#scanner').modal('show');
    }
});

$('#scanner').on('show.bs.modal', function () {
    const scannerUrl = $(this).find('.scanner-container').attr('data-url');

    $(this).find('.scanner-container').append(
        `<iframe width="100%" height="auto" id="scanner" style="width: 100%; height: 100%; min-height: 90dvh;" src="${scannerUrl}" allow="camera ${scannerUrl}; microphone ${scannerUrl}/"></iframe>`
    );
});

$('#scanner').on('hide.bs.modal', function () {
    if (window.innerWidth < 992) {
        $(this).find('.scanner-container iframe').remove();
    }
});

window.addEventListener('message', function(event) {
    let scannerData;

    try {
        scannerData = JSON.parse(event.data);
    } catch (e) {
        scannerData = null;
    }

    if (scannerData && scannerData?.name === 'scannerImage') {
        let file = dataURLtoFile(scannerData.data, 'ocr.png');
        let container = new DataTransfer();
        container.items.add(file);
        $('.ocr-file').prop('files', container.files).trigger('change');
        $('#scanner').modal('hide');
    }
});

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}